/***
 * Intl Polyfill
 *
 */
var intl = require("intl");
require("intl/locale-data/jsonp/en");

module.exports = intl;
